<template>
  <b-container>
  </b-container>
</template>

<script>

export default {
  name: "FactorAutoPrint",
}
</script>

<style scoped>

</style>